import {
  CBadge,
  CButton,
  CCol,
  CInputGroup,
  CLabel,
  CRow,
} from "@coreui/react";
import React, { useState } from "react";
import Auth from "src/auth";
import { apiCall, downloadUrl } from "src/_apiConfig/apiCall";
import CommonList from "src/views/common/CommonList";

const LotListViewGoDownRent = (props) => {
  const { authenticated } = Auth();
  /* File upload start */
  const [selectedGoDownRentTDSFile, setselectedGoDownRentTDSFile] = useState();
  const [fileEventGoDownRentTDSFile, setfileEventGoDownRentTDSFile] =
    useState(false);

  let scopedSlotsGodownRentList = {
    PaymentStatus: (item, index) => {
      return (
        <td className="py-2">
          {item.godownRentPaymentStatus === "Paid" ? (
            <CBadge color="success" className="mfs-auto badgeFont100">
              {item.godownRentPaymentStatus}
            </CBadge>
          ) : item.godownRentPaymentStatus === "Pending" ? (
            <CBadge color="warning" className="mfs-auto badgeFont100">
              {item.godownRentPaymentStatus}
            </CBadge>
          ) : (
            <CBadge color="danger" className="mfs-auto badgeFont100">
              {item.godownRentPaymentStatus}
            </CBadge>
          )}
        </td>
      );
    },
  };
  const itemGodownRentList = [
    {
      quantity: props.viewListDetails.quantity,
      actualbags: props.viewListDetails.actualbags,
      godownrent: props.viewListDetails.godownrent,

      totalRent: props.viewListDetails.totalRent,
      godownRentLateFee: props.viewListDetails.godownRentLateFee,
      tds_godownrent: props.viewListDetails.tds_godownrent,
      godownrent_cgst: props.viewListDetails.godownrent_cgst,
      godownrent_sgst: props.viewListDetails.godownrent_sgst,
      godownrent_igst: props.viewListDetails.godownrent_igst,
      godownRentPaymentStatus: props.viewListDetails.godownRentPaymentStatus,
    },
  ];
  const fieldsGodownRent = [
    {
      key: "quantity",
      label: "Quantity",
      sorter: false,
      filter: false,
    },
    {
      key: "actualbags",
      label: "Actual Quantity",
      sorter: false,
      filter: false,
    },
    {
      key: "godownrent",
      label: "Godown Rent",
      sorter: false,
      filter: false,
    },
    {
      key: "totalRent",
      label: "Total Rent",
      sorter: false,
      filter: false,
    },
    {
      key: "godownRentLateFee",
      label: "Late Fee",
      sorter: false,
      filter: false,
    },

    {
      key: "tds_godownrent",
      label: "TDS",
      sorter: false,
      filter: false,
    },

    {
      key: "godownrent_cgst",
      label: "CGST",
      sorter: false,
      filter: false,
    },
    {
      key: "godownrent_sgst",
      label: "SGST",
      sorter: false,
      filter: false,
    },
    {
      key: "godownrent_igst",
      label: "IGST",
      sorter: false,
      filter: false,
    },
    {
      key: "PaymentStatus",
      label: "Status",
      sorter: false,
      filter: false,
    },
  ];

  // const handleDownloadGoDownRent = async (lotPaymentId) => {
  //   await apiDownloadDocument(
  //     `${props.viewListDetails.godownRentDownloadURL}`,
  //     `${downloadUrl}/${props.viewListDetails.godownRentDownloadURL}`
  //   ).then((res) => {
  //     if (res.success) alert(res.message);
  //     else alert(res.message);
  //   });
  // };

  const payGoDownRent = async (amount, isWithOutTDS, tds_path) => {
    if (isWithOutTDS && props.viewListDetails.godownrent_tds_path === "") {
      alert("Please upload the tds certficate");
    } else {
      props.ConfirmationPopupHandler(
        5,
        1,
        "Are you sure you want to proceed for Payment?",
        amount,
        props.viewListDetails.lotId,
        0,
        0,
        props.viewListDetails.godownRentLateFee,
        0,
        0,
        0,
        0,
        isWithOutTDS,
        tds_path
      );
    }
  };

  const GodownRentTDSForm = async (id) => {
    let e = fileEventGoDownRentTDSFile;
    if (e !== false) {
      if (authenticated) {
        if (e.target.files[0].type === "application/pdf") {
          e.preventDefault();
          // setSelectedFile(e.target.files[0]);
          const files = e.target.files;
          const formData = new FormData();
          const header = new Headers();
          header.append("Accept", "application/json");
          formData.append("file", files[0]);
          const response = await apiCall(
            `LotDetails/UploadGodownRentTDSFile/${id}/${e.target.files[0].name}`,
            "POST",
            header,
            formData
          );
          await response.text();
          if (response.status === 200) {
            alert("Uploaded Successfully!");
            setselectedGoDownRentTDSFile();
            setfileEventGoDownRentTDSFile(false);
            window.location.reload();
          } else {
            alert("Error to upload file!");
          }
        } else {
          alert("Please Upload Only pdf file!");
        }
      }
    } else {
      alert("Please Choose A File!");
    }
  };
  return (
    <>
      {/* <CRow className="pl-1 pr-1 pt-3 mt-3">
        <CCol className="mb-2" xl={12}>
          <strong>Godown Rent </strong>
          <CLabel
            style={{
              fontStyle: "italic",
              color: "red",
            }}
          >
            ({props.viewListDetails.lastDateOfGodownRentPay})
          </CLabel>
        </CCol>
      </CRow> */}
      <div className="viewTable  pl-1 pr-1 pt-1 mt-1">
        <CommonList
          listName={
            <>
              Godown Rent &nbsp;
              <CLabel
                style={{
                  fontStyle: "italic",
                  color: "red",
                  fontSize: "0.875rem",
                }}
              >
                {props.viewListDetails.lastDateOfGodownRentPay}
              </CLabel>
            </>
          }
          items={itemGodownRentList}
          fields={fieldsGodownRent}
          loading={false}
          disabledprev={true}
          disablednext={true}
          scopedSlots={scopedSlotsGodownRentList}
          displayPaggingButton={false}
        />
      </div>

      <CRow>
        <CCol className="mb-2 " xl={12}>
          {props.viewListDetails.godownRentPaymentId > 0 ? (
            // && authenticated.role === "Bidder"
            <CRow className={"mt-2"}>
              <CCol
                className="payment-label col-9"
                dangerouslySetInnerHTML={{
                  __html: props.viewListDetails.godownRentPaymentdescription,
                }}
              ></CCol>
              {/* <CLabel
                htmlFor="exampleFormControlInput1"
                className={"payment-label"}
              >
                {props.viewListDetails.godownRentPaymentdescription}
              </CLabel> */}
              {(props.viewListDetails.payGodwonRent !== "0.00" ||
                props.viewListDetails.payGodwonRent_without_tds !== "0.00") && (
                <CButton
                  color="info"
                  className="ml-2 mt-1"
                  style={{ height: "35px" }}
                  onClick={() =>
                    props.ViewBankTransaction(props.viewListDetails.lotId, "GR")
                  }
                >
                  History
                </CButton>
              )}
              <CButton
                color="info"
                className="ml-2 mt-1"
                style={{ height: "35px" }}
                onClick={() =>
                  props.PaymentStatusViewHanlder(
                    props.viewListDetails.godownRentPaymentTranId
                  )
                }
              >
                Receipt
              </CButton>
              {/* {props.viewListDetails.godownRentPaymentStatus === "Paid" && (
                <CButton
                  color="info"
                  className="ml-2 mt-1"
                  style={{  height: "35px" }}
                  onClick={() =>
                    handleDownloadGoDownRent(
                      props.viewListDetails.godownRentDownloadURL
                    )
                  }
                >
                  Download
                </CButton>
              )} */}
            </CRow>
          ) : (
            <>
              {authenticated.role === "Bidder" &&
                props.viewListDetails.isLotLeftHOApproval !== true && (
                  <>
                    {props.viewListDetails.payGodwonRent !== "0.00" && (
                      <CButton
                        color="info"
                        className="ml-2 mt-2"
                        onClick={() =>
                          payGoDownRent(
                            props.viewListDetails.payGodwonRent,
                            false,
                            ""
                          )
                        }
                      >
                        Pay Now = {props.viewListDetails.payGodwonRent}
                      </CButton>
                    )}

                    {props.viewListDetails.payGodwonRent_without_tds !==
                      "0.00" && (
                      <CButton
                        color="info"
                        className="ml-2 mt-2"
                        onClick={() =>
                          payGoDownRent(
                            props.viewListDetails.payGodwonRent_without_tds,
                            true,
                            props.viewListDetails.godownrent_tds_path
                          )
                        }
                      >
                        Pay After TDS ={" "}
                        {props.viewListDetails.payGodwonRent_without_tds}
                      </CButton>
                    )}
                  </>
                )}
            </>
          )}

          {props.viewListDetails.godownrent_tds_path !== "" && (
            <a
              target="_blank"
              href={`${downloadUrl}/${props.viewListDetails.godownrent_tds_path}`}
              rel="noreferrer"
            >
              <CButton className="ml-2 mt-2" color="info">
                View TDS Challan
              </CButton>
            </a>
          )}
        </CCol>
        {props.viewListDetails.godownRentPaymentStatus !== "Paid" &&
          authenticated.role === "Bidder" &&
          props.viewListDetails.godownrent_tds_path === "" &&
          props.viewListDetails.isLotLeftHOApproval !== true && (
            <CCol
              xl={4}
              disabled={props.viewListDetails.godownrent_tds_path !== ""}
            >
              <CInputGroup className="mb-3">
                <div className="custom-file">
                  <input
                    name="file"
                    disabled={props.viewListDetails.godownrent_tds_path !== ""}
                    id="inputGroupFile01"
                    type="file"
                    accept=".pdf"
                    className="custom-file-input"
                    onChange={(e) => {
                      setfileEventGoDownRentTDSFile(e);
                      setselectedGoDownRentTDSFile(e.target.files[0]);
                    }}
                  />
                  <label
                    className="custom-file-label"
                    htmlFor="inputGroupFile01"
                  >
                    {selectedGoDownRentTDSFile ? (
                      selectedGoDownRentTDSFile.name
                    ) : (
                      <>Choose file</>
                    )}
                  </label>
                </div>
                <div>
                  <CButton
                    className="ml-3 mt-1"
                    color="success"
                    disabled={props.viewListDetails.godownrent_tds_path !== ""}
                    onClick={() =>
                      GodownRentTDSForm(props.viewListDetails.lotId)
                    }
                    // enabled={uploadBtn === false ? true : false}
                  >
                    Upload TDS Challan
                  </CButton>
                </div>
              </CInputGroup>
            </CCol>
          )}
      </CRow>
      {/* <CRow className="pt-3 pl-5 pr-5 mt-3">
              <CCol className="mb-2" xl={12}>
                <strong>Godown Rent </strong>
                <CLabel
                  style={{
                    fontStyle: "italic",
                    color: "red",
                  }}
                >
                  ({viewListDetails.lastDateOfGodownRentPay})
                </CLabel>
              </CCol>
            </CRow>
            <CRow className="pl-5 pr-5">
              <CCol className="mb-2" xl={12}>
                <hr></hr>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  <strong>Quantity :</strong>
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  <strong>Actual Quantity :</strong>
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  <strong>Godown Rent :</strong>
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  <strong>Total Rent :</strong>
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  <strong>Late Fee :</strong>
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  <strong>TDS :</strong>
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  <strong>CGST :</strong>
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  <strong>SGST :</strong>
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  <strong>IGST :</strong>
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={2}>
                <CLabel htmlFor="exampleFormControlInput1">
                  <strong> Status :</strong>
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}></CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  {viewListDetails.quantity}
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  {viewListDetails.actualbags}
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  {viewListDetails.godownrent}
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  {viewListDetails.totalRent}
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  {viewListDetails.godownRentLateFee}
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  {viewListDetails.tds_godownrent}
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  {viewListDetails.godownrent_cgst}
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  {viewListDetails.godownrent_sgst}
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}>
                <CLabel htmlFor="exampleFormControlInput1">
                  {viewListDetails.godownrent_igst}
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={2}>
                <CLabel htmlFor="exampleFormControlInput1">
                  {viewListDetails.godownRentPaymentStatus === "Paid" ? (
                    <span
                      className="badge bg-success text-light"
                      style={{ padding: "10px" }}
                    >
                      {viewListDetails.godownRentPaymentStatus}
                    </span>
                  ) : viewListDetails.godownRentPaymentStatus === "Pending" ? (
                    <span
                      className="badge bg-warning text-dark"
                      style={{ padding: "10px" }}
                    >
                      {viewListDetails.godownRentPaymentStatus}
                    </span>
                  ) : (
                    <span
                      className="badge bg-danger text-light"
                      style={{ padding: "10px" }}
                    >
                      {viewListDetails.godownRentPaymentStatus}
                    </span>
                  )}
                </CLabel>
              </CCol>
              <CCol className="mb-2" xl={1}></CCol>
              <CCol className="mb-2" xl={12}>
                <CLabel htmlFor="exampleFormControlInput1"></CLabel>

                {viewListDetails.godownRentPaymentId > 0 ? (
                  // && authenticated.role === "Bidder"
                  <>
                    <CLabel htmlFor="exampleFormControlInput1">
                      {viewListDetails.godownRentPaymentdescription}
                    </CLabel>
                    <CButton
                      color="info"
                      className="ml-2 mt-1"
                      hidden={
                        viewListDetails.payGodwonRent !== "0.00" ||
                        viewListDetails.payGodwonRent_without_tds !== "0.00"
                          ? false
                          : true
                      }
                      onClick={() =>
                        ViewBankTransaction(viewListDetails.lotId, "GR")
                      }
                    >
                      History
                    </CButton>
                    <CButton
                      color="info"
                      className="ml-2 mt-1"
                      onClick={() =>
                        PaymentStatusViewHanlder(
                          viewListDetails.godownRentPaymentTranId
                        )
                      }
                    >
                      Receipt
                    </CButton>

                    <a
                      target="_blank"
                      href={`${downloadUrl}/${viewListDetails.godownRentDownloadURL}`}
                      rel="noreferrer"
                    >
                      <CButton
                        color="info"
                        hidden="true"
                        className="ml-2 mt-1"
                      >
                        Download
                      </CButton>
                    </a>
                  </>
                ) : (
                  <>
                    {/* {viewListDetails.payGodwonRent} -
                  {viewListDetails.payGodwonRent_without_tds} * /}
                    <CButton
                      color="info"
                      className="ml-2"
                      hidden={
                        authenticated.role === "Bidder" &&
                        viewListDetails.payGodwonRent !== "0.00"
                          ? false
                          : true
                      }
                      // GoDowonRentPayment(
                      //   viewListDetails.lotId,
                      //   viewListDetails.payGodwonRent,
                      //   viewListDetails.godownRentLateFee,
                      //   false,
                      //   ""
                      // )
                      onClick={() =>
                        ConfirmationPopupHandler(
                          5,
                          1,
                          "Are you sure you want to proceed for Payment?",
                          viewListDetails.payGodwonRent,
                          viewListDetails.lotId,
                          0,
                          0,
                          viewListDetails.godownRentLateFee,
                          0,
                          0,
                          0,
                          0,
                          false,
                          ""
                        )
                      }
                    >
                      Pay Now = {viewListDetails.payGodwonRent}
                    </CButton>
                    <CButton
                      color="info"
                      className="ml-2"
                      hidden={
                        authenticated.role === "Bidder" &&
                        viewListDetails.payGodwonRent_without_tds !== "0.00"
                          ? false
                          : true
                      }
                      // GoDowonRentPayment(
                      //   viewListDetails.lotId,
                      //   viewListDetails.payGodwonRent_without_tds,
                      //   viewListDetails.godownRentLateFee,
                      //   true,
                      //   viewListDetails.godownrent_tds_path
                      // )
                      onClick={() =>
                        ConfirmationPopupHandler(
                          5,
                          1,
                          "Are you sure you want to proceed for Payment?",
                          viewListDetails.payGodwonRent,
                          viewListDetails.lotId,
                          0,
                          0,
                          viewListDetails.godownRentLateFee,
                          0,
                          0,
                          0,
                          0,
                          true,
                          viewListDetails.godownrent_tds_path
                        )
                      }
                    >
                      Pay After TDS ={" "}
                      {viewListDetails.payGodwonRent_without_tds}
                    </CButton>
                  </>
                )}

                {viewListDetails.godownrent_tds_path !== "" ? (
                  <a
                    target="_blank"
                    href={`${downloadUrl}/${viewListDetails.godownrent_tds_path}`}
                    rel="noreferrer"
                  >
                    <CButton className="ml-2" color="info">
                      View TDS Challan
                    </CButton>
                  </a>
                ) : (
                  ""
                )}
              </CCol>
              <CCol
                xl={4}
                disabled={viewListDetails.godownrent_tds_path !== ""}
                hidden={authenticated.role !== "Bidder"}
              >
                <CInputGroup className="mb-3">
                  <div className="custom-file">
                    <input
                      name="file"
                      disabled={viewListDetails.godownrent_tds_path !== ""}
                      id="inputGroupFile01"
                      type="file"
                      accept=".pdf"
                      className="custom-file-input"
                      onChange={(e) => {
                        setfileEventGoDownRentTDSFile(e);
                        setselectedGoDownRentTDSFile(e.target.files[0]);
                      }}
                    />
                    <label
                      className="custom-file-label"
                      htmlFor="inputGroupFile01"
                    >
                      {selectedGoDownRentTDSFile ? (
                        selectedGoDownRentTDSFile.name
                      ) : (
                        <>Choose file</>
                      )}
                    </label>
                  </div>
                  <div>
                    <CButton
                      className="ml-3"
                      color="success"
                      disabled={viewListDetails.godownrent_tds_path !== ""}
                      onClick={() => GodownRentTDSForm(viewListDetails.lotId)}
                      // enabled={uploadBtn === false ? true : false}
                    >
                      Upload TDS Challan
                    </CButton>
                  </div>
                </CInputGroup>
              </CCol>
            </CRow> */}
    </>
  );
};

export default LotListViewGoDownRent;
